var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-button',{attrs:{"isActive":_vm.isActive.heading({ level: 1 }),"icon":'h1'},on:{"click":function($event){_vm.commands.heading({ level: 1 })}}})}
var staticRenderFns = []

export { render, staticRenderFns }